'use client'
import ServerErrorStdPage from 'storefront-modules/common/components/ServerErrorStdPage'

// No `metadata` export: error boundaries must be client components, where Next ignores metadata,
// and since Next 16.4 this module is evaluated eagerly in the browser — a module-level
// metadataFactory() call crashes every page (site.url comes from a server-only env var).
const ErrorPage = () => {
  return <ServerErrorStdPage text="Error 500." />
}

export default ErrorPage
